import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { TerraaChat } from "./TerraaChat";

export const AiChatWidget = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  if (pathname === "/ask-terraa") return null;

  return (
    <>
      {open && (
        <div
          data-testid="ai-widget-panel"
          className="fixed bottom-24 right-4 sm:right-6 z-50 w-[min(94vw,400px)] h-[min(72vh,560px)] bg-white border-2 border-[#113835] shadow-[0_30px_70px_rgba(17,56,53,0.3)] flex flex-col"
        >
          <div className="bg-[#113835] px-5 py-3.5 flex items-center justify-between shrink-0">
            <p className="font-heading text-[0.68rem] uppercase tracking-[0.2em] text-[#F4D387] flex items-center gap-2">
              <Sparkles size={13} /> Terraa AI
            </p>
            <button data-testid="ai-widget-close" onClick={() => setOpen(false)} className="text-white/70 hover:text-white" aria-label="Close chat">
              <X size={16} />
            </button>
          </div>
          <div className="flex-1 min-h-0">
            <TerraaChat compact />
          </div>
        </div>
      )}
      <button
        data-testid="ai-widget-button"
        onClick={() => setOpen((o) => !o)}
        aria-label="Ask Terraa AI"
        className="fixed bottom-6 right-24 z-50 h-14 rounded-full bg-[#113835] text-[#F4D387] flex items-center gap-2 px-5 shadow-lg hover:scale-105 transition-transform border border-[#C1A74A]/50"
      >
        <Sparkles size={18} strokeWidth={1.5} />
        <span className="font-heading text-[0.68rem] uppercase tracking-[0.16em] hidden sm:inline">Ask Terraa AI</span>
      </button>
    </>
  );
};
